import Plain from "@/types/Plain";

export function arrayOf<T extends Record<string, any>>(object: Record<string, T>, key: string): (T & Record<string, string>)[] {
    const array: (T & Record<string, string>)[] = []
    for (const p in object) {
        const element = { ...object[p], [key]: p } as T & Record<string, string>
        array.push(element)
    }
    return array
}

export function objectOf<T extends Record<string, any>>(array: T[], key: string, preserve = false): Record<string, any> {
    return array.reduce((object: Record<string, any>, element: T) => {
        if (!preserve) {
            const newElement = { ...element }
            delete newElement[key]
            object[element[key]] = newElement
        } else {
            object[element[key]] = element
        }
        return object
    }, {})
}

export function asArray<T>(elements: T | T[] | undefined | null): T[] {
    return Array.isArray(elements) ? elements : elements !== undefined && elements !== null ? [elements] : []
}

export function asElement<T>(elements: T | T[] | undefined | null): T | undefined {
    if (Array.isArray(elements)) {
        return elements.length > 0 ? elements[0] : undefined
    } else return elements as T | undefined
}

export function asElementOrArray<T>(elements: T | T[]): T | T[] {
    return Array.isArray(elements) && elements.length == 1 ? elements[0] : elements
}

export default { arrayOf, objectOf, asArray, asElement, asElementOrArray }
